<template>
  <div class="showInfo">
    <div class="tips">
      <Tag v-show="modalVal.payStatus===1" color="warning">未支付</Tag>
      <Tag v-show="modalVal.payStatus===3" color="success">支付成功</Tag>
      <Tag v-show="modalVal.payStatus===6" color="error">退款</Tag>
    </div>

    <div class="orderInfo">
      <Row>
        <Col span="8">
          <b>订单编号:{{modalVal.orderID}}</b>
        </Col>
        <Col span="8">
          订单状态:{{modalVal.payStatus===1?'未支付':(modalVal.payStatus===3?'已支付':'退款')}}
        </Col>
        <Col span="8">
          支付时间:{{modalVal.payTime}}
        </Col>
      </Row>
      <Row>
        <Col span="8">
          用户名:{{modalVal.userName}}
        </Col>
        <Col span="8">
          报名时间:{{modalVal.addTime}}
        </Col>
        <Col span="8">
          订单总金额:￥{{modalVal.classMoney}}
        </Col>
      </Row>
      <Row>
        <!--        <Col span="8">-->
        <!--&lt;!&ndash;          真实姓名:{{modalVal.trueName}}&ndash;&gt;-->
        <!--        </Col>-->
        <!--        <Col span="8">-->

        <!--        </Col>-->
        <Col span="8">
          优惠减免: -￥{{modalVal.discountMoney}}
        </Col>
        <Col span="8">
          实付金额:￥{{modalVal.payMoney}}
        </Col>
      </Row>
    </div>

    <div class="orderList">
      <Table :loading="loading" border :columns="columns" :data="res.list"></Table>
    </div>

    <div class="shouYi" v-show="modalVal.payStatus===3">
      <h4>收益</h4>
      <Row>
        <Col span="8">
          可分成订单金额:￥{{res.divideOrderMoney}}
        </Col>
        <Col span="8">
          分成比例:{{res.orderProportion}}%
        </Col>
        <Col span="8">

        </Col>
      </Row>
    </div>

    <div class="tuiKuan" v-show="modalVal.payStatus===4">
      <h4>退款明细</h4>
      <Row>
        <Col span="8">
          申请时间:{{res.orderApplyRefoundTime}}
        </Col>
        <Col span="8">
          退款时间:{{res.orderRefoundTime}}
        </Col>
        <Col span="8">

        </Col>
      </Row>
      <Row>
        <Col span="8">
          退款原因:{{res.orderRefoundReason | returnMap(0)}}
        </Col>
        <Col span="8"></Col>
        <Col span="8"></Col>
      </Row>
      <Row>
        <Col span="8">
          退款金额:￥{{res.orderRefoundMoney}}
        </Col>
        <Col span="8"></Col>
        <Col span="8"></Col>
      </Row>
    </div>

  </div>
</template>

<script>

  const maps = new Map([
    [0, '默认值'],
    [1, '优惠退款'],
    [2, '教材退款'],
    [23, '保价退款'],
    [25, '报考失败退款'],
    [26, '差价退款'],
  ]);

  export default {
    name: "index",
    props: {
      modalVal: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        status: 1,
        loading: true,
        info: {},
        res: {},
        columns: [
          {
            title: "订单明细",
            key: "courseName",
            width: 300
          }, {
            title: "价格",
            key: "price",
          }, {
            title: "教辅",
            key: "jiaoFu",
          }, {
            title: "加价教材",
            key: "addPriceBuy",
          }, {
            title: "保价",
            key: "insuredDay",
            render: (h, params) => {
              if (params.row.insuredDay > 0) {
                return h("span", {
                  style: {
                    color: '#19BE6B'
                  }
                }, "保价")
              } else {
                return h("span", {
                  style: {
                    color: '#FF9900'
                  }
                }, '无')
              }
            }
          }, {
            title: "有效期",
            key: "validTime",
            width: 200
          },
        ],
        tblData: []
      }
    },
    methods: {
      getInfo(val) {
        console.log(val);
        const params = {
          orderID: val.orderID,
          // type: val.payStatus
        };
        this.$store.dispatch('effect/getPayOrder', params).then(res => {
          console.log(res);
          this.loading = false;
          this.res = res;
        });
      }
    },
    filters: {
      returnMap(text, index) {
        let tmp = [maps];
        return tmp[index].get(text);
      }
    },
    created() {
      this.info = this.modalVal;
      this.getInfo(this.info);
    },
  }
</script>

<style scoped lang="scss">
  .showInfo {
    position: relative;

    .tips {
      position: absolute;
      right: 0;
      top: 0;
    }

  }

  .orderList, .shouYi, .tuiKuan {
    margin-top: 20px;
  }

  .ivu-col {
    line-height: 30px;
  }
</style>